import { AccountSettingsTab, AccountSettingsView } from 'src/app/enums/accountSettings.enum';
import { AccountSettingsTabOption, AccountSettingsViewSize } from 'src/app/models/accountSettings.model';

export const TWO_FACTOR_CODE_LENGTH = 6;
export const TWO_FACTOR_RESEND_COOLDOWN_SECONDS = 30;
export const JOB_TITLE_MAX_LENGTH = 80;

export const ACCOUNT_SETTINGS_TABS: AccountSettingsTabOption[] = [
    { id: AccountSettingsTab.Alerts, name: 'Alerts', icon: 'bell' },
    { id: AccountSettingsTab.RegionTime, name: 'Region & time', icon: 'globe' },
    { id: AccountSettingsTab.Units, name: 'Units', icon: 'ruler' },
    { id: AccountSettingsTab.Security, name: 'Security', icon: 'shield' },
];

export const ACCOUNT_SETTINGS_DIALOG_WIDTH = '780px';
export const ACCOUNT_SETTINGS_PANEL_CLASS = 'account-settings-dialog';

export const ACCOUNT_SETTINGS_VIEW_SIZES: AccountSettingsViewSize[] = [
    { view: AccountSettingsView.Settings, width: ACCOUNT_SETTINGS_DIALOG_WIDTH },
    { view: AccountSettingsView.SmsOptIn, width: '560px' },
    { view: AccountSettingsView.SmsVerify, width: '560px' },
    { view: AccountSettingsView.TwoFactor, width: '480px' },
    { view: AccountSettingsView.ChangePassword, width: '480px' },
];
